import React, { Fragment, useState, useEffect } from 'react';
import Table from '../../../components/table/table';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import axiosInstance from '../../../utility/axios-instance';
import PutAwayPopup from './putAwayPopup';
import QcPopup from './qcPopup';
import InboundDialog from './inboundPopup';
import SnackBar from '../../../components/SnackBar';
import FormDialog from '../../../components/FormDialog/FormDialog';
import { IconButton, Tooltip, Typography } from '@mui/material';
import Permission from '../../auth/permissions';
import { services } from '../../../utility/checkRoleBasedPermission';
import { useNavigate } from 'react-router-dom';
import { setInwardPurchaseOrders } from '../../../store/inwardPoOrders';
import { setInboundPO } from '../../../store/inboundPoOrders';
import { setQCPurchaseOrders } from '../../../store/qcPurchaseOrders';
import { setPutAwayPurchaseOrders } from '../../../store/putAwayPoOrders';
import UploadFileSharpIcon from '@mui/icons-material/UploadFileSharp';
import InvoiceDialog from './invoiceDialog';
import ChallanDialog from './challanDialog';
import ForceCloseDialog from './forceCloseDialog';
import moment from 'moment';

const PoInwards = ({ type }) => {
    const [snackBar, setSnackBar] = useState({ display: false, type: "success", message: "default message!" })
    const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
    const [inwardPoRowData, setInwardPoRowData] = useState(null);
    const [challanDialogOpen, setChallanDialogOpen] = useState(false);
    const [products,setProducts] = useState([]);

    const handleForceClose = (row) => {
        axiosInstance.put(`/purchaseOrders/forceClosePo/${row?.purchaseOrderName}`)
            .then(res => {
                const successMessage = res?.data?.message
                setSnackBar((prevSnackBar) => {
                    return { ...prevSnackBar, display: true, message: successMessage, type: "success" }
                });
            })
            .catch(error => {
                console.log(error);
                const errorMessage = error?.response?.data?.message
                setSnackBar((prevSnackBar) => {
                    return { ...prevSnackBar, display: true, message: errorMessage, type: "error" }
                });
            })

        setReRender(!reRender);
    }

    const columnVisibilityModelPOTable = {
        locationName: false,
        openQty: false,
        createdBy: false
    }

    const handleInvoiceDialogOpen = (row) => {
        setInwardPoRowData(row);
        setInvoiceDialogOpen(true);
    };

    const handleInvoiceDialogClose = () => {
        setInvoiceDialogOpen(false);
        setInwardPoRowData(null);
    };

    const handleChallanDialogOpen = (row) => {
        setInwardPoRowData(row);
        setChallanDialogOpen(true);
    };

    const handleChallanDialogClose = () => {
        setChallanDialogOpen(false);
        setInwardPoRowData(null);
    };

    const InboundRenderCell = (row) => {
        return (
            <Permission service={services?.inwardPurchaseOrders} permission={"update"}>
                <Tooltip title={'Invoice Upload'}>
                    <IconButton onClick={(e) => { handleInvoiceDialogOpen(row) }}>
                        <UploadFileSharpIcon />
                    </IconButton>
                </Tooltip>
            </Permission>
        )
    }

    const EstimateDate = (row)=>{
        return <div>
            {
                row?.estimateDate
                ? moment(row?.estimateDate)
                    .format('MMM DD, YYYY')
                : "N/A"
            }
        </div>
    }

    const CreatedBy = (row)=>{
        return <div style={{
            color: row?.interWareHouseId ? "lightseagreen" : '#000'
            }}>
            {row?.createdBy}
        </div>
    }

    const ChallanRenderCell = (row) => {
        return (
            <Permission service={services?.inwardPurchaseOrders} permission={"update"}>
                <Tooltip title={'Challan Upload'}>
                    <IconButton onClick={(e) => { handleChallanDialogOpen(row) }}>
                        <UploadFileSharpIcon />
                    </IconButton>
                </Tooltip>
            </Permission>
        )
    };

    const handleForceCloseOpen = (purchaseOrder) => {
        setPurchaseOrder(purchaseOrder)
        setForceCloseDialogOpen(true);
    }

    const InboundBtnRenderCell = (row) => {
        return (
            <Fragment>
                {+row?.openQty > 0 && 
                    <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', gap: '10px' }}>
                        <Permission service={services?.inwardPurchaseOrders} permission={"create"}>
                            <Button
                                variant="contained"
                                size='small'
                                color="primary"
                                onClick={() => handleClickOpen(row)}
                                sx={{ 
                                    fontSize: '0.6rem',
                                    padding: '0.2rem 0.5rem',
                                }}
                            >Inbound</Button>
                        </Permission>

                        <Permission service={services?.inwardPurchaseOrders} permission={"create"}>
                            <Button
                                variant="outlined"
                                // size='small'
                                color="primary"
                                onClick={() => handleForceCloseOpen(row)}
                                sx={{ 
                                    fontSize: '0.6rem',
                                    padding: '0.2rem 0.5rem',
                                }}
                            >Force Close</Button>
                        </Permission>

                        {/* <Permission service={services?.inwardPurchaseOrders} permission={"update"}>
                            <FormDialog
                                dialogTitle="Force Close"
                                dialogActionType="confirmation"
                                openDialogButtonName="Force Close"
                                submitDialogButtonName="Submit"
                                onConfirmation={() => { handleForceClose(row) }}
                            >
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Are you sure you want to force close this po?
                                </Typography>
                            </FormDialog>
                        </Permission> */}
                    </div>
                }
            </Fragment>
        )
    }

    const columns = [
        {
            field: 'purchaseOrderName',
            headerName: 'PO Name',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.purchaseOrderName}</div>
            )
        },
        {
            field: 'vendorName',
            headerName: 'Vendor',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.vendorName}</div>
            )
        },
        {
            field: 'locationCode',
            headerName: 'Location Code',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.locationCode}</div>
            )
        },
        {
            field: 'locationName',
            headerName: 'Location Name',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.locationName}</div>
            )
        },
        {
            field: 'status',
            headerName: 'SO Status',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.status}</div>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            flex: 1.4,
            sortable: true,
            filterable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.createdAt}</div>
            )
        },
        {
            field: 'totalAmount',
            headerName: 'Amount',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            valueFormatter: (params) => `₹${params.value}`,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.totalAmount}</div>
            )
        },
        {
            field: 'openQty',
            headerName: 'Open Qty',
            flex: 0.7,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>{params?.row?.openQty}</div>
            )
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => ( <CreatedBy {...params?.row} /> ),
            customRenderCell: CreatedBy
        },
        {
            field: 'estimateDate',
            headerName: 'Estimate Date',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => ( <EstimateDate {...params?.row} /> ),
            customRenderCell: EstimateDate
        },
        {
            field: 'invoice',
            headerName: 'Invoice',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            flex: 0.7,
            padding: 5,
            filterable: false,
            sortable: false,
            renderCell: (params) => ( <InboundRenderCell {...params?.row} /> ),
            customRenderCell: InboundRenderCell
        },
        {
            field: 'challan',
            headerName: 'Challan',
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            flex: 0.7,
            padding: 5,
            filterable: false,
            sortable: false,
            renderCell: (params) => ( <ChallanRenderCell {...params?.row} />),
            customRenderCell: ChallanRenderCell
        },
        {
            field: 'Inbound',
            headerName: 'Inbound',
            headerClassName: 'super-app-theme--header',
            flex: 1.5,
            filterable: false,
            sortable: false,
            renderCell: (params) => ( <InboundBtnRenderCell {...params?.row} />),
            customRenderCell: InboundBtnRenderCell
        },
    ];

    const columnVisibilityModelInboundTable = {
        qcStatus: false
    }

    const QcBtnRenderCell = (row) => {
        return (
            <Permission service={services?.inwardPurchaseOrders} permission={"update"}>
                <Button
                    variant="contained"
                    size='small'
                    color="primary"
                    onClick={() => handleQcOpen(row)}
                >QC</Button>
            </Permission>
        )
    }

    const inboundColumns = [
        {
            field: 'inboundNumber',
            headerName: 'Inbound No.',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.inboundNumber}
                </div>
            )
        },
        {
            field: 'orderName',
            headerName: 'Order No.',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.orderName}
                </div>
            )
        },
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1.4,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.sku}
                </div>
            )
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            type: 'number',
            flex: 0.7,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.quantity}
                </div>
            )
        },
        {
            field: 'qcStatus',
            headerName: 'QC Status',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcStatus}
                </div>
            )
        },
        {
            field: 'type',
            headerName: 'Type',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.type}
                </div>
            )
        },
        {
            field: 'locationCode',
            headerName: 'Location Code',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.locationCode}
                </div>
            )
        },
        {
            field: 'stagingBinCode',
            headerName: 'Staging Bin Code',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.stagingBinCode}
                </div>
            )
        },
        {
            field: 'user',
            headerName: 'Created By',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.user}
                </div>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            flex: 1.9,
            sortable: true,
            filterable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.createdAt}
                </div>
            )
        },
        {
            field: 'QC',
            headerName: 'QC',
            headerClassName: 'super-app-theme--header',
            filterable: false,
            flex: 0.8,
            sortable: false,
            renderCell: (params) => ( <QcBtnRenderCell {...params?.row} />),
            customRenderCell: QcBtnRenderCell
        },
    ];

    const PutAwayBtnRenderCell = (row) => {
        return (
            <Permission service={services?.inwardPurchaseOrders} permission={"update"}>
                <Button
                    variant="contained"
                    size='small'
                    color="primary"
                    onClick={() => handlePutawayOpen(row)}
                >PutAway</Button>
            </Permission>
        )
    }

    const qcColumns = [
        {
            field: 'inboundNumber',
            headerName: 'Inbound No.',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.inboundNumber}
                </div>
            )
        },
        {
            field: 'orderName',
            headerName: 'Order No.',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.orderName}
                </div>
            )
        },
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1.7,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.sku}
                </div>
            )
        },
        {
            field: 'locationCode',
            headerName: 'Location Code',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.locationCode}
                </div>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            flex: 1.9,
            sortable: true,
            filterable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.createdAt}
                </div>
            )
        },
        {
            field: 'qcPass',
            headerName: 'Pass',
            type: 'number',
            flex: 0.6,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcPass}
                </div>
            )
        },
        {
            field: 'qcFail',
            headerName: 'Fail',
            type: 'number',
            flex: 0.6,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcFail}
                </div>
            )
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            type: 'number',
            flex: 0.6,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.quantity}
                </div>
            )
        },
        {
            field: 'qcPerson',
            headerName: 'QC Person',
            flex: 0.8,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcPerson}
                </div>
            )
        },
        {
            field: 'qcStatus',
            headerName: 'Status',
            flex: 0.7,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcStatus}
                </div>
            )
        },

        {
            field: 'PutAway',
            headerName: 'PutAway',
            headerClassName: 'super-app-theme--header',
            filterable: false,
            flex: 1,
            sortable: false,
            renderCell: (params) => ( <PutAwayBtnRenderCell {...params?.row} />),
            customRenderCell: PutAwayBtnRenderCell
        },

    ];

    const putAwayColumns = [
        {
            field: 'orderName',
            headerName: 'Order No.',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.orderName}
                </div>
            )
        },
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1.7,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.sku}
                </div>
            )
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            type: 'number',
            flex: 0.7,
            headerClassName: 'super-app-theme--header',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.quantity}
                </div>
            )
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.7,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.status}
                </div>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            flex: 1.9,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.createdAt}
                </div>
            )
        },
        {
            field: 'locationCode',
            headerName: 'Location Code',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.locationCode}
                </div>
            )
        },
        {
            field: 'qcPass',
            headerName: 'Qc Pass Qty',
            headerClassName: 'super-app-theme--header',
            flex: 0.8,
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcPass}
                </div>
            )
        },
        {
            field: 'passBinCode',
            headerName: 'Saleable Bin Code',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.passBinCode}
                </div>
            )
        },
        {
            field: 'qcFail',
            headerName: 'Qc Fail Qty',
            headerClassName: 'super-app-theme--header',
            flex: 0.8,
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.qcFail}
                </div>
            )
        },
        {
            field: 'failBinCode',
            headerName: 'Rejected Bin Code',
            headerClassName: 'super-app-theme--header',
            flex: 0.8,
            filterable: true,
            renderCell: (params) => (
                <div style={{color: params?.row?.interWareHouseId ? "lightseagreen" : '#000'}}>
                    {params?.row?.failBinCode}
                </div>
            )
        }
    ];

    const [types, setTypes] = useState(type ? type : 'new');
    const [alignment, setAlignment] = useState(type ? type : 'new');
    const [reRender, setReRender] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [forceCloseDialogOpen, setForceCloseDialogOpen] = useState(false);
    const [binsForInbound, setBinsForInbound] = useState([]);
    const [binId, setBinId] = useState(null);
    const [binIdForInbound, setBinIdForInbound] = useState(null);
    const [locations, setLocations] = useState([]);
    const [locationCode, setLocationCode] = useState(null);
    const [locationCodeForInbound, setLocationCodeForInbound] = useState(null);
    const [returnId, setReturnId] = useState(null);
    const [inboundDetails, setInboundDetails] = useState(null);
    const [selectedSku, setSelectedSku] = useState(null);
    const [rejectBinId, setRejectBinId] = useState(null);
    const [quantity, setQuantity] = useState(null);
    const [purchaseOrder, setPurchaseOrder] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const inwardPurchaseOrders = useSelector((state) => state.inwardPurchaseOrders);
    const inboundPO = useSelector((state) => state.inboundPO);
    const qcPurchaseOrders = useSelector((state) => state.qcPurchaseOrders);
    const putAwayPurchaseOrders = useSelector((state) => state.putAwayPurchaseOrders);
    const handleQcOpen = (details) => {
        setInboundDetails(details);
        setOpen(true);
    }

    const handleQcClose = () => {
        setInboundDetails(null);
        setOpen(false);
        setReRender(!reRender);
    }

    const handleClickOpen = (purchaseOrder) => {
        setPurchaseOrder(purchaseOrder)
        setOpen(true);
        setLocationCodeForInbound(purchaseOrder?.locationCode);
    };

    const handleClose = () => {
        setReturnId(null);
        setBinId(null);
        setBinIdForInbound(null);
        setRejectBinId(null);
        setLocationCode(null);
        setLocationCodeForInbound(null);
        setQuantity('');
        setReRender(!reRender);
        setOpen(false);
    };

    const handleForceCloseDialog = () => {
        setForceCloseDialogOpen(false);
    }

    const reRenderInwardPo = () => {
        setReRender(!reRender);
    }

    const handlePutawayOpen = async (purchaseOrder) => {
        setProducts(purchaseOrder)
        setOpen(true);
        setLocationCode(purchaseOrder?.locationCode);
        setSelectedSku(purchaseOrder?.sku)
    };


    const handleChange = (event) => {
        setTypes(event.target.value);
        setAlignment(event.target.value);
        navigate(`/inwardPurchaseOrders${event.target.value === 'new' ? '' : `/${event.target.value}`}`)
    };

    useEffect(() => {
        axiosInstance.get(`/location/locations?text=`)
            .then(res => {
                const locations = [];
                for (let location of res?.data?.data) {
                    locations.push(location?.locationCode)
                }
                setLocations(locations)
            })
            .catch(error => {
                console.log(error);
            })
    }, []);

    useEffect(() => {
        if (locationCodeForInbound) {
            axiosInstance.get(`/inventory/bins?locationCode=${locationCodeForInbound}&type=Staging`)
                .then(res => {
                    let bins = res?.data?.data?.bins;
                    setBinsForInbound(bins.map((bin) => bin.code))
                })
                .catch(error => {
                    console.log(error);
                })
        }
    }, [locationCodeForInbound])

    const fetchLineItemsFromPurchaseOrder = async (purchaseOrderName) => {
        try {
            await axiosInstance.get(`/purchaseOrders/purchaseOrderDetails/${purchaseOrderName}`)
                .then((res) => {
                    setProducts(res?.data?.data?.PoLineItems)
                })
                .catch((err) => {
                    console.log(err)
                })

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        if (purchaseOrder) {
            fetchLineItemsFromPurchaseOrder(purchaseOrder?.purchaseOrderName);
        }
    }, [purchaseOrder])

    useEffect(() => {
        const params = {
            locationCode: locationCode,
            sku: selectedSku
        }
        axiosInstance.get(`/orderAllocation/fetchOrderAllocationFromBinAndLocation`, { params })
            .then(res => {
                if (res?.data?.data?.length > 0) {
                    setBinId(res?.data?.data[0]?.Bin)
                } else {
                    setBinId(null)
                }
            })
            .catch(error => {
                console.log(error);
            })
    }, [locationCode, selectedSku]);

    return (
        <Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0px' }}>
                <div style={{ backgroundColor: '#EDEDF7', borderRadius: 4, padding: 4 }}>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleChange}
                        aria-label="Platform"
                        sx={{
                            "& .MuiToggleButtonGroup-grouped": { border: '0px', color: 'black', textTransform: 'capitalize', padding: '2px 11px' },
                            "& .MuiToggleButton-root.Mui-selected": { backgroundColor: '#fff' }
                        }}
                    >
                        <ToggleButton value="new">New</ToggleButton>
                        <ToggleButton value="inbound">Inbound</ToggleButton>
                        <ToggleButton value="qc">Q.C</ToggleButton>
                        <ToggleButton value="putaway">Put Away</ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>

            {types === 'new' && (
                <div>
                    <Table
                        columns={columns}
                        dataPosition={"purchaseOrders"}
                        endpoint={`/purchaseOrders/purchaseOrders?tab='inwardPO'`}
                        rowId={'purchaseOrderId'}
                        rowSelectionEndpoint={`/pgOrder/admin/createReturnInbound`}
                        version="version-1"
                        reRender={reRender}
                        columnVisibilityModel={columnVisibilityModelPOTable}
                        initialFilterState={{ items: [{ field: 'openQty', operator: '>', value: 0 }] }}
                        service={'purchaseOrders'}
                        type={types}
                        tabName={'Inward Po'}
                        setData={setInwardPurchaseOrders}
                        data={inwardPurchaseOrders}
                        mobileResponsive={true}
                        exportEndpoint={`/exports/fetchPurchaseOrders?tab='inwardPO'`}
				        exportFileName={`Inward Purchase Orders - ${new Date()}`}
                    />

                    <div>
                        <InvoiceDialog
                            invoiceDialogOpen={invoiceDialogOpen}
                            handleInvoiceDialogClose={handleInvoiceDialogClose}
                            invoiceRowData={inwardPoRowData}
                            setReRender={reRenderInwardPo}
                        />
                        <ChallanDialog
                            challanDialogOpen={challanDialogOpen}
                            handleChallanDialogClose={handleChallanDialogClose}
                            challanRowData={inwardPoRowData}
                            setReRender={reRenderInwardPo}
                        />
                    </div>
                </div>
            )}

            {types === 'inbound' && (
                <Table
                    columns={inboundColumns}
                    dataPosition={"fetchedReturns"}
                    endpoint={`/pgOrder/admin/returnsInbound?type=purchaseOrder`}
                    rowId={'id'}
                    version="version-1"
                    reRender={reRender}
                    columnVisibilityModel={columnVisibilityModelInboundTable}
                    service={'inwardPurchaseOrders'}
                    type={types}
                    tabName={'Inward Po'}
                    setData={setInboundPO}
                    data={inboundPO}
                    mobileResponsive={true}
                    exportEndpoint={`/exports/fetchReturnsInboundOrders?type=purchaseOrder`}
				    exportFileName={`Inward Purchase Orders - ${new Date()}`}
                />
            )}

            {types === 'qc' && (
                <Table
                    columns={qcColumns}
                    dataPosition={"fetchedReturns"}
                    endpoint={`/pgOrder/admin/returnsQcMarked?type=purchaseOrder`}
                    rowId={'id'}
                    reRender={reRender}
                    service={'inwardPurchaseOrders'}
                    type={types}
                    tabName={'Inward Po'}
                    setData={setQCPurchaseOrders}
                    data={qcPurchaseOrders}
                    mobileResponsive={true}
                    exportEndpoint={'/exports/fetchReturnQcDoneOrders?type=purchaseOrder'}
                    exportFileName={`Return QC Done Orders - ${new Date()}`}
                />
            )}

            {types === 'putaway' && (
                <Table
                    columns={putAwayColumns}
                    dataPosition={"fetchedReturns"}
                    endpoint={`/pgOrder/admin/returnsPutAway`}
                    rowId={'id'}
                    reRender={reRender}
                    service={'inwardPurchaseOrders'}
                    type={types}
                    tabName={'Inward Po'}
                    setData={setPutAwayPurchaseOrders}
                    data={putAwayPurchaseOrders}
                    mobileResponsive={true}
                    exportEndpoint={'/exports/fetchReturnsPutAwayOrders'}
                    exportFileName={`Return PutAway Orders - ${new Date()}`}
                />
            )}

            {types === 'new' && products?.length > 0 && (
                <InboundDialog
                    title={`Inbound Purchase Order:- ${purchaseOrder?.purchaseOrderName}`}
                    Id={purchaseOrder?.purchaseOrderName}
                    products={products}
                    bins={binsForInbound}
                    locationCode={locationCodeForInbound}
                    open={open}
                    handleClose={handleClose}
                />
            )}

            {types === 'inbound' && (
                <QcPopup
                    open={open}
                    handleClose={handleQcClose}
                    inboundDetails={inboundDetails}
                    loading={loading}
                    setLoading={setLoading}
                    url={"/purchaseOrders/qualityCheckInboundPo"}
                />
            )}

            {types === 'qc' && (
                <PutAwayPopup
                    title={'Put Away'}
                    open={open}
                    handleClose={handleClose}
                    locationCode={locationCode}
                    returnId={products}
                />
            )}

            <ForceCloseDialog 
                title={`Force Close Purchase Order:- ${purchaseOrder?.purchaseOrderName}`}
                purchaseOrderName={purchaseOrder?.purchaseOrderName}
                products={products}
                bins={binsForInbound}
                locationCode={locationCodeForInbound}
                open={forceCloseDialogOpen}
                handleClose={handleForceCloseDialog}
                setSnackBar={setSnackBar}
                setReRender={setReRender}
                reRender={reRender}
            />

            <SnackBar snackBar={snackBar} setSnackBar={setSnackBar} />
        </Fragment>
    )
}
export default PoInwards;